import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadService } from '../../../api/services/file-upload.service';
import { FileUploaded } from '../../../api/models/file-uploaded';

@Component({
  selector: 'app-files-modal',
  templateUrl: './files-modal.component.html',
  styleUrls: ['./files-modal.component.scss']
})
export class FilesModalComponent implements OnInit {

  @Input() filesAttached: string[];
  @Input() type: string;

  files: FileUploaded[] = [];
  fileIds: string[] = [];

  constructor(public activeModal: NgbActiveModal,
              private fileUploadService: FileUploadService
  ) { }

  onUploaded(id: string) {
    this.fileUploadService.get(id).subscribe(file => {
      this.files.push(file);
      this.fileIds.push(file.id);
    });
  }

  ngOnInit() {
    if (this.type === 'View') {
      for (const fileId of this.filesAttached) {
        this.fileUploadService.get(fileId).subscribe(file => {
          this.files.push(file);
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/files-modal/files-modal.component.ts